import { memo } from 'react'
import { styled } from '@mui/material'
import { MagnifyingGlass } from '@phosphor-icons/react'
import { rem } from 'polished'

export interface GlobalSearchFieldAnchorProps {
  placeholder: string
  onClick: () => void
}

const GlobalSearchFieldAnchorWrapper = styled('button')(({ theme }) => ({
  width: rem('170px'),
  height: rem('28px'),
  background: theme.colours.baseExtraLight,
  borderRadius: theme.display.borderRadius,
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  borderStyle: 'solid',
  borderColor: theme.colours.foreground,
  borderWidth: theme.display.inputBorderWidth,
  '&:hover': {
    borderColor: theme.colours.baseLight,
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.colours.baseMid,
  fontSize: theme.typography.pxToRem(14),
}))

const _GlobalSearchFieldAnchor = ({ placeholder, onClick }: GlobalSearchFieldAnchorProps): JSX.Element => (
  <GlobalSearchFieldAnchorWrapper onClick={onClick}>
    <span>{placeholder}</span>
    <MagnifyingGlass size={16} weight="bold" />
  </GlobalSearchFieldAnchorWrapper>
)

const GlobalSearchFieldAnchor = memo(_GlobalSearchFieldAnchor)

export default GlobalSearchFieldAnchor
